
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/portable-power-station-and-charger",
      function () {
        return require("private-next-pages/portable-power-station-and-charger/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/portable-power-station-and-charger"])
      });
    }
  